import {otherRouter, appRouter} from '@/plugins/router/router';

const fault = {
    state: {
        faultList: []
    },
    mutations: {
        addFault(state,fault){
            state.faultList.unshift(fault);
            localStorage.faultList=JSON.stringify(state.faultList);
            document.getElementById("fault-list").scrollTop=0;
        },
        setFaultList (state) {
            state.faultList =localStorage.faultList?JSON.parse(localStorage.faultList):[];
        },
        removeFault (state, insert_time) {
            state.faultList.forEach((item,index)=>{
                if(item.insert_time===insert_time){
                    state.faultList.splice(index,1);
                }
            });
            localStorage.faultList=JSON.stringify(state.faultList);
        },
        clearAll(state){
            state.faultList=[];
            localStorage.removeItem("faultList")
        },
    }
};
export default fault;